import axiosInstance from './axiosInstance';

/*=============PERSONAS========*/
// Obtener todas las personas
export const fetchPersons = async () => {
  const response = await axiosInstance.get('/persons');
  return response.data;
};

export const fetchPersonSearch = async (search = '', limit = 10, offset = 0) => {
  const res = await axiosInstance.get('/persons/basic/search', {
    params: { search, limit, offset }
  });
  return res.data;
};

// Obtener una persona por DNI
export const fetchPersonByDNI = async (dni) => {
  const response = await axiosInstance.get(`/persons/dni/${dni}`);
  return response.data;
};

// Crear una nueva persona
export const createPerson = async (data) => {
  const response = await axiosInstance.post('/persons', data);
  return response.data;
};

// Actualizar una persona
export const updatePerson = async (id, data) => {
  const response = await axiosInstance.put(`/persons/${id}`, data);
  return response.data;
};

// Eliminar una persona
export const deletePerson = async (id) => {
  const response = await axiosInstance.delete(`/persons/${id}`);
  return response.data;
};

export const createPersonLocationFull = async (personId, data) => {
  const response = await axiosInstance.post(`/persons/${personId}/locations/full`, data);
  return response.data;
};

export const updatePersonLocation = async (personId, locId, data) => {
  const response = await axiosInstance.put(`/persons/${personId}/locations/${locId}`, data);
  return response.data;
};

export const deletePersonLocation = async (personId, locId) => {
  const response = await axiosInstance.delete(`/persons/${personId}/locations/${locId}`);
  return response.data;
};

export const fetchPersonById = async (id) => {
  const response = await axiosInstance.get(`/persons/${id}`);
  return response.data;
};

/*=============VEHICULOS========*/
export const fetchVehicles = async () => {
  const response = await axiosInstance.get('/vehicles');
  return response.data;
};

// Crear una nuevo vehiculo
export const createVehicle = async (data) => {
  const response = await axiosInstance.post('/vehicles', data);
  return response.data;
};

// Actualizar un vehiculo
export const updateVehicle = async (id, data) => {
  const response = await axiosInstance.put(`/vehicles/${id}`, data);
  return response.data;
};

// Eliminar un vehiculo
export const deleteVehicle = async (id) => {
  const response = await axiosInstance.delete(`/vehicles/${id}`);
  return response.data;
};

export const getVehicleById = async (id) => {
  const response = await axiosInstance.get(`/vehicles/${id}`);
  return response.data;
};

/*=============DOCUMENTOS========*/
export const fetchDocuments = async () => {
  const response = await axiosInstance.get('/documents');
  return response.data;
};

export const getDocumentsByEmpleado = async (empID) => {
  const response = await axiosInstance.get(`/documents/${empID}/employee`);
  return response.data;
};

export const getDocumentsByVehicle = async (vehID) => {
  const response = await axiosInstance.get(`/documents/${vehID}/vehicle`);
  return response.data;
};

export const createDocument = async (data) => {
  try {
    const response = await axiosInstance.post("/documents", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    console.error("Error en createDocument:", error.response?.data || error.message);

    return {
      success: false,
      error: error.response?.data?.error || "Error al registrar el documento.",
      status: error.response?.status || 500,
    };
  }
};

export const updateDocument = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/documents/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    console.error("Error en updateDocument:", error.response?.data || error.message);

    return {
      success: false,
      error: error.response?.data?.error || "Error al actualizar el documento.",
      status: error.response?.status || 500,
    };
  }
};


// Eliminar un documento
export const deleteDocument = async (id) => {
  const response = await axiosInstance.delete(`/documents/${id}`);
  return response.data;
};

export const fetchDocumentFile = async (filePath) => {
  const response = await axiosInstance.get(`/documents/file/${filePath}`, {
    responseType: "blob", // Para recibir el archivo como Blob
  });

  return URL.createObjectURL(response.data); // Crear una URL temporal para mostrar en el `iframe`
};


/*=============TIPO DE DOCUMENTOS========*/
export const fetchDocumentsType = async () => {
  const response = await axiosInstance.get('/documentsType');
  return response.data;
};

// Crear un nuevo documento
export const createDocumentType = async (data) => {
  const response = await axiosInstance.post('/documentsType', data);
  return response.data;
};

// Actualizar un documento
export const updateDocumentType = async (id, data) => {
  const response = await axiosInstance.put(`/documentsType/${id}`, data);
  return response.data;
};

// Eliminar un documento
export const deleteDocumentType = async (id) => {
  const response = await axiosInstance.delete(`/documentsType/${id}`);
  return response.data;
};

/*=============ORGANIZACION_CLI========*/
// Obtener todas las organizaciones
export const fetchOrganizations = async () => {
  const response = await axiosInstance.get('/organizations');
  return response.data;
};

// Crear una nueva organización
export const createOrganization = async (data) => {
  const response = await axiosInstance.post('/organizations', data);
  return response.data;
};

// Actualizar una organización
export const updateOrganization = async (id, data) => {
  const response = await axiosInstance.put(`/organizations/${id}`, data);
  return response.data;
};

// Eliminar una organización
export const deleteOrganization = async (id) => {
  const response = await axiosInstance.delete(`/organizations/${id}`);
  return response.data;
};

/*=============PROYECTO_CLI========*/
// Obtener todos los proyectos
export const fetchProjects = async () => {
  const response = await axiosInstance.get('/projects');
  return response.data;
};

// Obtener los proyectos por ID
export const fetchProjectsById = async (projectId) => {
  const response = await axiosInstance.get('/projects/:id');
  return response.data;
};

// Crear un nuevo proyecto
export const createProject = async (data) => {
  const response = await axiosInstance.post('/projects', data);
  return response.data;
};

// Actualizar un proyecto
export const updateProject = async (id, data) => {
  const response = await axiosInstance.put(`/projects/${id}`, data);
  return response.data;
};

// Eliminar un proyecto
export const deleteProject = async (id) => {
  const response = await axiosInstance.delete(`/projects/${id}`);
  return response.data;
};

/*=============PROYECTO_DOCUMENTS_CLI========*/
// Obtener todos los documentos requeridos de un proyecto
export const fetchProjectDocuments = async (projectId) => {
  const response = await axiosInstance.get(`/projectDocuments/${projectId}`);
  return response.data;
};

// Crear un nuevo documento requerido para un proyecto
export const createProjectDocument = async (data) => {
  const response = await axiosInstance.post("/projectDocuments", data);
  return response.data;
};

// Actualizar un documento requerido por un proyecto
export const updateProjectDocument = async (id, data) => {
  const response = await axiosInstance.put(`/projectDocuments/${id}`, data);
  return response.data;
};

// Eliminar un documento requerido por un proyecto
export const deleteProjectDocument = async (id) => {
  const response = await axiosInstance.delete(`/projectDocuments/${id}`);
  return response.data;
};

// Validar documentos de un empleado o vehículo para un manifiesto
export const validateProjectDocuments = async (manifestId, entityId, typeUser) => {
  const response = await axiosInstance.get(`/manifests/${manifestId}/validar-documentos`, {
    params: { entityId, typeUser }
  });
  return response.data;
};

export const getEnableEmployees = async (projectId) => {
  const response = await axiosInstance.get(`/projectDocuments/${projectId}/validar-empleados`);
  return response.data;
};

export const getEnableVehicles = async (projectId) => {
  const response = await axiosInstance.get(`/projectDocuments/${projectId}/validar-vehiculos`);
  return response.data;
};

/*============= MANIFIESTOS ==========*/

export const fetchManifiestosFiltered = async ({
  serProInt,
  tipoServicioId,
  tipoServicioCodigo,
  proyectoId,
  estados,
  limit = 100,
  offset = 0,
} = {}) => {
  const params = {
    limit,
    offset,
  };

  if (typeof serProInt === "boolean") {
    params.serProInt = serProInt;
  }

  if (tipoServicioId !== undefined && tipoServicioId !== null) {
    params.tipoServicioId = tipoServicioId;
  }

  if (tipoServicioCodigo) {
    params.tipoServicioCodigo = tipoServicioCodigo;
  }

  if (proyectoId !== undefined && proyectoId !== null) {
    params.proyectoId = proyectoId;
  }

  if (Array.isArray(estados) && estados.length > 0) {
    params.estados = estados.join(",");
  }

  const response = await axiosInstance.get("/manifests/filtered", {
    params,
  });

  return response.data;
};

// Obtener todos los manifiestos
export const fetchManifiestos = async () => {
  const response = await axiosInstance.get("/manifests");
  return response.data;
};

/*export const fetchManifiestosInternos = async ({ limit = 100, offset = 0 } = {}) => {
  const response = await axiosInstance.get("/manifests/internos", { params: { limit, offset } });
  return response.data; // { data, pagination }
};*/

export const fetchManifiestosInternos = async ({
  limit = 100,
  offset = 0,
} = {}) => {
  return fetchManifiestosFiltered({
    serProInt: true,
    limit,
    offset,
  });
};

/*export const fetchManifiestosExternos = async ({ limit = 100, offset = 0 } = {}) => {
  const response = await axiosInstance.get("/manifests/externos", { params: { limit, offset } });
  return response.data;
};*/

export const fetchManifiestosExternos = async ({
  limit = 100,
  offset = 0,
} = {}) => {
  return fetchManifiestosFiltered({
    serProInt: false,
    limit,
    offset,
  });
};

export const fetchManifiestosTaxi = async ({
  serProInt,
  limit = 100,
  offset = 0,
} = {}) => {
  return fetchManifiestosFiltered({
    tipoServicioCodigo: "TAXI",
    serProInt,
    limit,
    offset,
  });
};

// Obtener un manifiesto por ID
export const fetchManifiestoById = async (id) => {
  const response = await axiosInstance.get(`/manifests/${id}`);
  return response.data;
};

// Obtener lista de manifiestos por Cliente ID
export const fetchManifiestosByUserProjects = async () => {
  const response = await axiosInstance.get(`/manifests/by-user-projects`);
  return response.data;
};

// Crear un nuevo manifiesto
export const createManifiesto = async (data) => {
  const response = await axiosInstance.post("/manifests", data);
  return response.data;
};

// Actualizar un manifiesto
export const updateManifiesto = async (id, data) => {
  const response = await axiosInstance.put(`/manifests/${id}`, data);
  return response.data;
};

// Eliminar un manifiesto
export const deleteManifiesto = async (id) => {
  const response = await axiosInstance.delete(`/manifests/${id}`);
  return response.data;
};

// Generar PDF del manifiesto
export const getManifestPdf = async (id) => {
  const response = await axiosInstance.get(`/manifests/${id}/pdf`, {
    responseType: 'blob',
  });
  return response.data;
};

// Generar PDF del manifiesto sin filtro
export const getManifestPdfSF = async (id) => {
  const response = await axiosInstance.get(`/manifests/${id}/pdfv2`, {
    responseType: 'blob',
  });
  return response.data;
};

export const getManifestRoadSheet10 = async (id) => {
  const response = await axiosInstance.get(`/manifests/${id}/roadsheet10`, {
    responseType: 'blob',
  });
  return response.data;
};

// Generar PDF del mapa de ruta
export const getRoadMapPdf = async (id) => {
  const response = await axiosInstance.get(`/manifests/${id}/ruadpdf`, {
    responseType: 'blob',
  });
  return response.data;
};

// Enviar mensajes via whastapp
export const sendMessageWhatsapp = async (manifestId) => {
  const response = await axiosInstance.post(`/manifests/${manifestId}/whatsapp`);
  return response.data;
};

// Actualizar el estado del manifiesto
export const updateManifestState = async (id, data) => {
  const response = await axiosInstance.put(`/manifests/${id}/estado`, data);
  return response.data;
};

/*============= PASAJEROS-MANIFIESTOS ==========*/

// Obtener los pasajeros de un manifiesto
export const fetchPasajeros = async (manifiestoDetalleId) => {
  const response = await axiosInstance.get(`/manifests/${manifiestoDetalleId}/pasajeros`);
  return response.data;
};

// Agregar un pasajero a un manifiesto
export const addPasajero = async (manifiestoDetalleId, data) => {
  const response = await axiosInstance.post(`/manifests/${manifiestoDetalleId}/pasajeros`, data);
  return response.data;
};

// Editar un pasajero en un manifiesto
export const updatePasajero = async (manifiestoDetalleId, data) => {
  const response = await axiosInstance.put(`/manifests/${manifiestoDetalleId}/pasajeros`, data);
  return response.data;
};

// Eliminar un pasajero de un manifiesto
export const deletePasajero = async (manifiestoDetalleId, data) => {
  const response = await axiosInstance.delete(`/manifests/${manifiestoDetalleId}/pasajeros`, {
    data,
  });

  return response.data;
};

/*============= ASIGNACIÓN DE EMPLEADOS Y VEHÍCULOS ==========*/

// Asignar un empleado a un manifiesto
export const assignEmployee = async (manifiestoId, data) => {
  const response = await axiosInstance.put(`/manifests/${manifiestoId}/empleados`, data);
  return response.data;
};

// Eliminar un empleado de un manifiesto
export const removeEmployee = async (manifiestoId, data) => {
  const response = await axiosInstance.delete(`/manifests/${manifiestoId}/empleados`, {
    data,
  });
  return response.data;
};

// Asignar un vehículo a un manifiesto
export const assignVehicle = async (manifiestoId, data) => {
  const response = await axiosInstance.put(`/manifests/${manifiestoId}/vehiculo`, data);
  return response.data;
};

// Eliminar el vehículo de un manifiesto
export const removeVehicle = async (manifiestoId, data) => {
  const response = await axiosInstance.delete(`/manifests/${manifiestoId}/vehiculo`, {
    data,
  });
  return response.data;
};
/*============= HISTORIAL ==========*/

// Obtener el historial de un manifiesto
export const fetchHistorial = async (id) => {
  const response = await axiosInstance.get(`/manifests/${id}/historial`);
  return response.data;
};

/*============= RUTAS ==========*/
export const fetchRutasByManifiesto = async (manifiestoId) => {
  const { data } = await axiosInstance.get(`/manifests/${manifiestoId}/paradas`);
  return data;
};

// Asignar nueva ruta con paradas
export const assignRutaToManifiesto = async (manifiestoId, payload) => {
  const { data } = await axiosInstance.put(`/manifests/${manifiestoId}/ruta`, payload);
  return data;
};

export const searchManifestsApi = async ({ q, limit = 10 }) => {
  const { data } = await axiosInstance.get(`/manifests/search`, {
    params: { q, limit },
  });

  // ✅ nuevo: soporte { items: [...] }
  if (Array.isArray(data?.items)) return data.items;

  // soportes anteriores
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.rows)) return data.rows;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.results)) return data.results;

  return [];
};

export const fetchManifestRouteTemplateApi = async (manifestId) => {
  const { data } = await axiosInstance.get(`/manifests/${manifestId}/route-template`);
  return data;
};